<template>
  <div>
    {{ data.priceBuy }} {{ data.currencyBuy.code }} ({{data.incotermBuy.name }})
  </div>
</template>

<script>

export default {
  props: ['data', 'index', 'column'],
}
</script>



// WEBPACK FOOTER //
// src/table/ColumnPriceBuy.vue